import * as React from "react";
import classNames from "classnames";
import { FooterContainer, HeaderContainer } from "..";

import "./page.scss";

interface IPageProps {
  children: React.ReactNode;
  width: "small" | "medium" | "large";
  className?: string;
  title?: string;
  showHeader?: boolean;
  showFooter?: boolean;
}
export const Page: React.FC<IPageProps> = ({
  children,
  className,
  width = "medium",
  title = null,
  showHeader = true,
  showFooter = true
}) => {
  const baseClassName = "page";
  className = classNames(baseClassName, className, {
    [`${baseClassName}--${width}`]: width
  });

  return (
    <div className={className}>
      {showHeader && <HeaderContainer />}

      {title !== null && (
        <div className={`${baseClassName}__title`}>
          <h1 className={`${baseClassName}__heading`}>{title}</h1>
        </div>
      )}

      <div className={`${baseClassName}__content`}>{children}</div>

      {showFooter && (
        <div className={`${baseClassName}__footer`}>
          <FooterContainer />
        </div>
      )}
    </div>
  );
};
